 function initReviewSlider() {
  var swiper = new Swiper(".MRSslider", {
    slidesPerView: 5,
    spaceBetween: 20,
    loop: true,
    freeMode: true, 
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 10
      },
      769: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1000: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  });
}
 var coll = document.getElementsByClassName("u-accordion-item-title");
        var i;
        for (i = 0; i < coll.length; i++) {
         coll[i].addEventListener("click", function() {
         this.classList.toggle("active");
         var content = this.nextElementSibling;
          if (content.style.maxHeight){
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}

 document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.m-custom-header');
    const updateHeaderHeight = () => {
      if (header) {
        const height = header.offsetHeight;
        document.documentElement.style.setProperty('--total-header-height', `${height}px`);
      }
    };
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    window.addEventListener('scroll', updateHeaderHeight);
  });
function initMpvsSlider() {
  var swiper = new Swiper(".MpvsSlider", {
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    speed: 1000,
    slidesPerView: 1,
  });
} 
function initCPSSlider() {
  var swiper = new Swiper(".MCPSSlider", {
    loop: true,
    navigation: {
      nextEl: ".m-cps-next",
      prevEl: ".m-cps-prev",
    },    
    spaceBetween: 5,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    speed: 1000,
    slidesPerView: 1,
  });
}
document.addEventListener('DOMContentLoaded', function () {
  const headings = document.querySelectorAll('.mfooter-block__heading');

  headings.forEach(heading => {
    heading.addEventListener('click', function () {
      const content = heading.nextElementSibling;

      if (!content || !content.classList.contains('mfooter-block__details-content')) return;

      const isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';

      if (isOpen) {
        content.style.maxHeight = '0px';
        heading.classList.remove('mactive');
        content.classList.remove('mactive');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        heading.classList.add('mactive');
        content.classList.add('mactive');
      }
    });
  });
});

